module.exports = __webpack_public_path__ + "img/co.0550ff4e.svg";